import type { InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetStore = ApiClient['v1']['store']['registry']['repositories']['$get'];
export type StoreServiceListResponse = InferResponseType<GetStore, 200>;
export type StoreService = StoreServiceListResponse['services'][number];

export function useStore() {
  return useFetch<StoreServiceListResponse>('/store', (client) =>
    client.v1.store.registry.repositories.$get({ query: {} })
  );
}
